

export const homeStyles = theme => ({
  errorStyle: {
    color: theme.palette.red,
    fontSize: '12px',
    margin: '0vh 5px',
    marginBottom: '5px',
  },
  error: {
    display: 'flex',
    marginTop: '2vh',
    justifyContent: 'center'
  },
  radioSelected:{
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '100%',
    alignItems: 'center'
  },
  radioOption:{
    width: '15px',
    height: '15px',
    opacity: '0.3',
    borderRadius:'5px',
    border: 'solid 1px black',
    backgroundColor: theme.palette.white,
    marginRight: '1vw',
    cursor: 'pointer'
  },
  radioContainer:{
    display: 'flex',
    marginRight: '5vw'
  },
  selectedRadio:{
    width: '7px',
    height: '7px',
    borderRadius: '2px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: theme.palette.red,
    opacity: '1'

  },
  selectedRadioOption:{
    opacity: '1',
    borderColor: theme.palette.red
  },
  radioLabel:{
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  radio: {
    fontSize: '13px',
    margin: '1vh 1vw',
    display: 'flex'
  },
  captchaContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    margin: '2vh 0vw'
  },
  formControl: {
    width: '100%'
  },
  categoryContainer: {
    width: '100%',
    fontSize: '12px',
    color: '#939292',
    fontWeight: '500',
    lineHeight: 'normal'
  },
  categoryText: {
    fontSize: '13px',
    fontWeight: '500',
    lineHeight: '1.8',
    color: '#271c1c'

  },
  loading: {
    color: theme.palette.white
  },
  updateInput: {
    margin: '0vh 1vw',
    fontSize: '13px',
    color: theme.palette.steelGray,
    height: '100%',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column'
  },
  icons: {
    marginRight: '3vw'
  },
  rightChevron: {
    color: theme.palette.red
  },
  noBorder: {
    border: 'none'
  },
  selectedListItem: {
    paddingLeft: '0px',
    paddingRight: '0px'
  },
  queryCancel: {
    color: theme.palette.steelGray,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column'

  },
  lineDivider: {
    borderRadius: '10px !important',
    padding: '0px 19px !important',
    border: 'none !important',
    height: '50px !important'
  },
  firstItem:{
    borderRadius: '10px !important',
    padding: '0px 19px !important',
    border: 'none !important',
    height: '50px !important'
  },
  menuContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  highlighted: {
    color: theme.palette.red,
    fontWeight: 'bold'
  },
  bottomContainer: {
    width: 'calc(100% - 60px)',
    display: 'flex',
    borderRadius: '10px',
    border: 'solid 1px rgba(0, 0, 0, 0.05)',
    backgroundColor: theme.palette.white,
    boxShadow: '0 0 19px 0 rgba(0, 0, 0, 0.07)',
    margin: '0vh 30px 3vh 30px'
  },
  menuIcon: {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    height: '100%',
    color: theme.palette.red,
    backgroundColor: theme.palette.white,
    padding: '0vh 1vh',
    borderTopLeftRadius: '10px',
    borderBottomLeftRadius: '10px',
    height: '6vh'
  },
  outerLoader: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '400px'
  },
  progress: {
    color: theme.palette.red,
  },
  bulletIcon: {
    color: theme.palette.red,
    fontSize: 'medium',
  },
  homeContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: `calc(100% - 1vh)`,
    backgroundColor: theme.palette.background,
    borderTopLeftRadius: '18px',
    borderTopRightRadius: '18px',
    paddingTop: '1vh',
    paddingLeft: '11px',
    paddingRight: '11px',
    width: 'calc(100% - 22px)'

  },
  queryContainer: {
    padding: '15px 15px 15px 0vw',
    marginRight: '15px',
    minHeight: '2vh',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.white,
    width: '100%'
  },
  ipContainer: {
    marginLeft: '0px',
    borderColor: theme.palette.silver,
    borderRadius: '10px',
    borderWidth: '1px',
    borderStyle: 'solid',
    marginRight: '0px',
    flexGrow: '1'

  },
  textFieldInput: {
    fontSize: '13px',
    borderRadius: '10px'
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '2vh'
  },

  cancelButton: {
    fontSize: '14px',
    color: theme.palette.black,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    fontWeight: '500',
    '&:hover': {
      backgroundColor: `${theme.palette.white} !important`,
    }
  },
  button: {
    backgroundColor: theme.palette.red,
    color: theme.palette.white,
    textTransform: 'unset',
    borderRadius: '10px',
    marginLeft: '1vw',
    marginRight: '1vw',
    fontSize: '14px',
    fontWeight: '500',
    width: '63px',
    height: '28px'
  },
  policyButton: {
    backgroundColor: theme.palette.red,
    color: theme.palette.white,
    textTransform: 'unset',
    borderRadius: '8px',
    marginLeft: '1vw',
    marginRight: '1vw',
    fontSize: '13px',
    fontWeight: '500',
    width: '100%'
  },
  doYouMeanText: {
    fontSize: '13px',
    color: theme.palette.warmGray,
    cursor: 'pointer',
  },
  listItems: {
    fontSize: '13px',
    marginLeft: '1vw',
    width: '80%'
  },
  inputRoot: {
    width: '200%'
  },
  name: {
    fontSize: '12px',
    fontWeight: 'bold',
    cursor: 'pointer'
  },
  email: {
    color: theme.palette.warmGray,
    cursor: 'pointer'
  },
  drawerPaper: {
    height: '80%',
    padding: '3vw 30px',
    borderTopRightRadius: '20px',
    borderTopLeftRadius: '20px',
    backgroundColor: theme.palette.white
  },
  loginDrawer: {
    height: '88%',
    padding: '3vw',
    borderTopRightRadius: '20px',
    borderTopLeftRadius: '20px',
    backgroundColor: theme.palette.white
  },
  selectedQuery: {
    margin: '0vh 1vw',
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '13px',
    width: '100%',
    cursor: 'pointer'
  },
  subHeader: {
    color: theme.palette.warmGray,
    fontSize: '12px',
    padding: '2vh 4vw 1vh 4vw'
  },
  policyContainer: {
    height: 'calc(100%  - 40px)',
    fontSize: '14px',
    backgroundColor: theme.palette.background,
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    padding: '20px 30px',
    lineHeight: '1.6'
  },
  listContainer: {
    backgroundColor: theme.palette.white,
    borderRadius: '10px',
    marginTop: '3VH'
  },

  policyListContainer: {
    backgroundColor: theme.palette.white,
    borderRadius: '10px',
    paddingBottom: '0vh',
    paddingTop: '0vh',
    marginTop: '2vh'
  },
});

export const loginStyles = theme => ({
  listItem: {
    '&:hover': {
      backgroundColor: `${theme.palette.paleGray} !important`
    }
  },
  loginDrawer: {
    height: '88%',
    padding: '3vw',
    borderTopRightRadius: '20px',
    borderTopLeftRadius: '20px',
    backgroundColor: theme.palette.white
  },
  container: {
    padding: '3vh 2vw',
    height: '100%'
  },
  heading: {
    fontSize: '14px',
    fontWeight: '500',
    marginBottom: '2vh',
    marginTop: '3vh',
    marginLeft: '16px'
  },
  forward: {
    position: 'absolute',
    right: '10px',
    top: '16px',
    color: theme.palette.red
  },
  name: {
    fontSize: '12px',
    margin: '0vh 2vw',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    fontWeight: '500'

  },
  desc: {
    fontSize: '10px',
    color: theme.palette.warmGray,
    margin: '0vh 2vw',
  }

})